<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
            <h2>
                {{ isEditMode ? $t("navigations.manage lab") : $t("navigations.create lab") }}
            </h2>
        </div>
        <div class="col-lg-2">
            <span class="tooltip-wrapper pointer" style="float:right">
                <i class="fa fa-times close" @click="onclosed()"></i>
                <span class="custom-tooltip closetooltipposition">Close</span>
            </span>
        </div>
    </div>
    <div class="wrapper wrapper-content">
        <div class="ibox-content p-3">
            <div class="form-group row">
                <!-- <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.lab id") }}</label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.labId" disabled />
                </div> -->
                <!-- <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.study name") }} <sup><i class="fa fa-asterisk imp"></i></sup></label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.studyRef" disabled  />
                    <span class="errormsg" v-if="errors[0] == false">{{ $t("navigations.please enter a study ref") }}</span>
                </div> -->
                <!-- <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.study id") }}  <sup><i class="fa fa-asterisk imp"></i></sup></label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.studyId" disabled  />
                    <span class="errormsg" v-if="errors[1] == false">{{ $t("navigations.please enter a study id") }}</span>
                </div> -->
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.lab code") }}<sup><i
                                class="fa fa-asterisk imp"></i></sup></label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.labCode" />
                    <span class="errormsg" v-if="errors[0] == false">{{ $t("navigations.please enter a lab code")
                        }}</span>
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.lab name") }}<sup><i
                                class="fa fa-asterisk imp"></i></sup></label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.labName" />
                    <span class="errormsg" v-if="errors[1] == false">{{ $t("navigations.please enter a lab name")
                        }}</span>
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.lab type") }}</label>
                    <select class="form-control" v-model="values.labType">
                        <option value="" disabled>Select Lab Type</option>
                        <option value="Central Laboratory">Central Laboratory</option>
                        <option value="Local Laboratory">Local Laboratory</option>
                    </select>
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.location") }}</label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.location" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.country code") }}</label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.countryCode" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.contact number") }}</label>
                    <input type="text" class="form-control" maxlength="20" v-model="values.phone" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.fax") }}</label>
                    <input type="text" class="form-control" maxlength="20" v-model="values.fax" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.contact email") }}</label>
                    <input type="email" class="form-control" maxlength="1000" v-model="values.contactEmail" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.primary contact name") }}</label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.primaryContactName" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.contact person email") }}</label>
                    <input type="email" class="form-control" maxlength="1000" v-model="values.primaryContactEmail" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.accreditation") }}</label>
                    <input type="text" class="form-control" maxlength="1000" v-model="values.accreditation" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.effective date") }}</label>
                    <input type="date" class="form-control" v-model="values.effectiveDate" />
                </div>
                <div class="col-lg-4 mb-1">
                    <label class="col-form-label">{{ $t("navigations.status") }}</label>
                    <select class="form-select mb-2" name="reason to resolve" id="resolveReason"
                        v-model="values.status">
                        <option value="" disabled>Select Status</option>
                        <option v-for="status in labStatus" :key="status.status" :value="status.status">{{ status.status
                            }}</option>
                    </select>
                </div>
                <div class="col-lg-12 my-3 d-flex justify-content-lg-end">
                    <button class="cancel_btn py-1 px-4 mx-3" type="button" @click.prevent="clear">
                        {{ $t("navigations.clear") }}
                    </button>
                    <button class="save_btn py-1 px-4" type="submit" @click.prevent="addLab">
                        <span v-if="showLoading">
                            <img src="../../assets/img/loading.gif" width="15" alt="Loading" />

                        </span>
                        <span v-else>
                            {{ $t("navigations.save") }}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>
<script src="./editLabs.js"></script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/savepages.css";

.wrapper-content {
    width: 100%;
}

textarea {
    width: 100%;
}

.imp {
    color: #ff0000;
    font-size: 7px;
}

.col-form-label {
    font-size: 12px;
}

.impcl {
    color: #ff4747;
    font-size: 25px;
    float: right;
}

.impcl:hover {
    color: #a30202;
    font-size: 25px;
    float: right;
}

.errormsg {
    color: red;
    font-size: 15px;
}

.form-select {
    border-radius: 0 !important;
}

.form-select:focus {
    border-color: #145faf !important;
    box-shadow: 0 0 0 !important;
}
</style>
